import { Component, OnInit, Output, EventEmitter, NgZone } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as Materialize from 'angular2-materialize/dist/index';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import { RecipesService } from './recipes.service';
import { NavbarService } from '../navbar/navbar.service';
import { ProjectsInfoService } from '../projectinfo/projectinfo.service';
import { UtilsService } from '../shared/utils.service';
import { GetFileTypeService } from '../shared/getFileType/get-file-type.service';
import { SharedService } from '../shared/shared.service';
import { BackButtonComponent } from '../shared/inAppBack/back-button/back-button.component';

import * as globals from '../globals';


declare let noUiSlider: any;
declare let jQuery: any;

@Component({
  selector: 'app-recipes',
  templateUrl: './recipes.component.html',
  styleUrls: ['./recipes.component.css'],
  providers: [RecipesService, ProjectsInfoService, GetFileTypeService]
})
export class RecipesComponent implements OnInit {

  waiticon: string;
  planid: string;
  recipeTabs: any = [];
  lotSize: Number = 1;
  public slider: any;
  loadingRecipes = true;
  noRecipes = true;
  recipes = [];
  recipeResources = [];
  previousMaterialRecipeResource: any = {};
  recipeMaterials = {};
  recipeProjectid;
  showmaterials = false;
  resources = [];
  recipeTemplates = [];
  recipeType = [];
  owners = [];
  reciperesources = [];
  recipecostings = [];
  recipematerials = [];
  recipecategory = [];
  recipecostingsDict: any = {};
  recipePage: boolean;
  newrecipeResource: any;
  newrecipeResourcesDict: any = {};
  newrecipeResourcesLength;
  loadingResources = true;
  categories = [];
  locations = [];
  costtypes = null;
  costtypeunits = null;
  costings = null;
  addnewCosting = {};
  categoriesDict = [];
  categoryIndexToIDDict: any = {};
  locationDict: any = {};
  costingtypeDict: any = {};
  recipetypeDict: any = {};
  ownersDict: any = {};
  costtypeunitsDict: any = {};
  editcategoryIndex: number;
  tabcategories: any = [];
  // tabmaterials: any = [];
  resourceSelectedCategory: number;
  loadingTemplate: boolean;
  noreciperesources: boolean;
  selectedRecipe: any;
  currentRecipeResource: any;
  currentRecipeCategory: any;
  currentrecipeIndex: number;
  currentrecipeResourceIndex: number;
  norecipematerial: boolean;
  materials = [];
  materialunits = [];
  materialshapes = [];

  materialselect: number;
  materialDict: any = {};
  materialUnitDict: any = {};
  materialPriceDict: any = {};
  materialDensityDict: any = {};
  materialshapeselect: number;
  materialshapeDict: any = {};

  boundingbox_length: number;
  boundingbox_width: number;
  boundingbox_height: number;

  stocksizeInch_unit: boolean = true;
  BoundingsizeInch_unit: boolean = true;
  projectRecipeMaterial = false;
  currentTabIndex: number;
  public dateFormat: string;
  public currencySymbol: string;
  public currencyName: string;
  changeMtrlCost: boolean = false;
  changeMtrlProperties: boolean;

  reciperesourcesDict: any = {};
  recipematerialsDict: any = {};
  recipeCostingDict: any = {};
  categoryDict: any = {};
  recipeCategoryDict: any = {};
  recipeCatDict: any = {};
  recipeResourceCosting: any = {};
  catagoryArray = [];
  tabLength: number;
  addActivityButtonStatus: boolean = true;
  changeCategorySelectStatus: boolean = false;

  filledstar: number;
  halfstar: number;
  emptystar: number;

  // the below variables have been added as a stand in until the component is completed
  // this stand is was created to allow the build server to build without flags
  user: any;
  selectOptions: any;
  number: any;
  revision: any;
  project = {
    thumbnail: '',
    name: '',
    number: 0,
    revision: 0,
  };
  checkedIndexes = [];

  tenanturl: any;
  tenantid: any;
  private bucketname = globals.BUCKETNAME;



  @Output()
  update: EventEmitter<any>;


  modalNewRecipeAction = new EventEmitter<string | MaterializeAction>();
  modalNewTemplateAction = new EventEmitter<string | MaterializeAction>();
  modalRecipeDetailsAction = new EventEmitter<string | MaterializeAction>();
  modalAddActivityAction = new EventEmitter<string | MaterializeAction>();
  // modalAddCategoryAction = new EventEmitter<string | MaterializeAction>();
  modalConfirmRemoveRecipeAction = new EventEmitter<string | MaterializeAction>();
  modalConfirmRemoveRecipeResourceAction = new EventEmitter<string | MaterializeAction>();
  modalCopyRecipeAction = new EventEmitter<string | MaterializeAction>();

  constructor(private router: Router,
              public recipesService: RecipesService,
              private ngZone: NgZone,
              private route: ActivatedRoute,
              private _ProjectsInfoService: ProjectsInfoService,
              private utilsService: UtilsService,
              private service: SharedService,
              private getFileTypeService: GetFileTypeService,
              public navService: NavbarService) {
    // this.recipeTabs[0].name = '';
    // this.recipeTabs[0].id = 0;
    // this.recipeTabs.push({name:'',id:0});
    this.update = new EventEmitter<any>();
  }

  ngOnDestroy() {
    this.modalNewRecipeAction.emit({ action: 'modal', params: ['close'] });
    this.modalNewTemplateAction.emit({ action: 'modal', params: ['close'] });
    this.modalRecipeDetailsAction.emit({ action: 'modal', params: ['close'] });
    this.modalAddActivityAction.emit({ action: 'modal', params: ['close'] });
    this.modalConfirmRemoveRecipeAction.emit({ action: 'modal', params: ['close'] });
    this.modalConfirmRemoveRecipeResourceAction.emit({ action: 'modal', params: ['close'] });
    this.modalCopyRecipeAction.emit({ action: 'modal', params: ['close'] });
  }

  ngOnInit() {
    this.recipePage = false;
    this.newrecipeResourcesLength = 0;

    this.dateFormat = localStorage.getItem('mr_date_format_id');
    this.currencySymbol = localStorage.getItem('mr_currency_symbol');
    this.currencyName = localStorage.getItem('mr_currency_id');

    this.tenantid = localStorage.getItem('mr_tenantid');
    this.planid = localStorage.getItem('mr_planid');
    let admin = localStorage.getItem('isAdmin');

    let projectid = +this.route.snapshot.paramMap.get('id');

    this.service.getProjectDetailsById(projectid).subscribe(
      data => {
        let parseddata = JSON.parse(data);
        console.log('PARSEDDATA:', parseddata);
        let project = parseddata.project;
        let filenamenoext = project.filename.replace(/\.[^/.]+$/, '');
        if (!filenamenoext) {
          filenamenoext = ' ';
        }

        if (this.planid === '3') {
          this.tenanturl = globals.GOVTENANTURL;
        } else {
          this.tenanturl = globals.TENANTURL;
        }
        // Determine the Model Type to show - based on the file extension
        project.modeltype = this.utilsService.getModelName(project.modeltype_id);
        if (project.modeltype != 0) {
          project.thumbnail = this.tenanturl + '/' + this.bucketname + '/' + this.tenantid + '/' + project.id + '/' + filenamenoext + '_320x240.png';
        } else {
          let ext = project.extension.toLowerCase();
          console.log('EXTENSION:', ext);
          project.thumbnail = this.getFileTypeService.returnFileTypeExtensionURLAppend96(ext);
        }

        console.log('thumbnail: ', project.thumbnail);

        this.recipeProjectid = project.id;
        this.project = { thumbnail: project.thumbnail, name: project.name, number: project.number, revision: project.revision };

        if (project.material_id) {
          this.showmaterials = true;
        }
        this.refreshRecipes(this.recipeProjectid);
      },
      error => {
        console.log('getProjectDetailsById error: ', error);
      }
    );
  }

  materialHeaderClicked(recipeId: number) {

    console.log('materialHeaderClicked');
    console.log(' Index : ', recipeId);


    if (document.getElementById(recipeId + '_materialcollapsible_body').className != 'active') {

      document.getElementById('materialarrowright' + recipeId).style.display = 'block';
      document.getElementById('materialarrowexpand' + recipeId).style.display = 'none';

    } else {
      document.getElementById('materialarrowright' + recipeId).style.display = 'none';
      document.getElementById('materialarrowexpand' + recipeId).style.display = 'block';
    }

  }

  resourceHeaderClicked(index: number, recipe: any, categoryId: number) {

    console.log('resourceHeaderClicked');
    console.log(' Index : ', index);

    if (document.getElementById(recipe.id + '_collapsible_body_' + index).className != 'active') {

      document.getElementById('categoryarrowexpand' + index + recipe.id).style.display = 'block';
      document.getElementById('categoryarrowright' + index + recipe.id).style.display = 'none';
      document.getElementById('categoryEdit' + index + recipe.id).style.display = 'inline-block';
      document.getElementById('categoryAdd' + index + recipe.id).style.display = 'inline-block';

    } else {

      this.cancelRecipeResourceEdit(index, recipe, categoryId);

      document.getElementById('categoryarrowexpand' + index + recipe.id).style.display = 'none';
      document.getElementById('categoryarrowright' + index + recipe.id).style.display = 'block';
      document.getElementById('categoryEdit' + index + recipe.id).style.display = 'none';
      document.getElementById('categoryAdd' + index + recipe.id).style.display = 'none';

    }
  }

  refreshRecipes(projectid) {

    this.loadingRecipes = true;
    this.recipeTabs = [];
    // this.getReciperesource();
    // this.getRecipecostings();
    // this.getResourcesCategory();
    this.refreshResources();
    this.getMaterialShape();
    // this.getMaterials();
    // this.getMaterialsUnit();
    this.getRecipe(projectid);
  }

  getRecipe(projectid) {

    this.loadingRecipes = true;
    this.recipesService.getRecipesProject(projectid)
      .subscribe(
      data => {

        console.log('Got Recipes');
        let result = JSON.parse(data);
        this.recipes = result.recipes;
        console.log('Recipes : ', this.recipes);

        this.recipeTemplates = result.templates;
        this.recipes = result.recipes;
        this.recipeType = result.recipetypes;
        this.owners = result.owners;
        this.reciperesources = result.reciperesources;
        this.recipecostings = result.recipecostings;
        this.recipecategory = result.recipecategory;
        this.materials = result.materials;
        this.recipematerials = result.recipematerials;

        this.updateAllVariables();

        if (this.currentTabIndex >= 0) {
          this.ngZone.onMicrotaskEmpty.first().subscribe(() => {
            console.log('recipetab' + this.currentTabIndex);
            let currntTabIndex = this.currentTabIndex;
            $(document).ready(function() {
              document.getElementById('recipetab' + currntTabIndex).click();
            });
          });
        }
      },
      error => {
        this.loadingRecipes = false;
        this.noRecipes = true;
      });
  }


  // Local update of UI
  updateAllVariables() {

    this.loadingRecipes = true;

    this.recipeTabs = [];
    this.tabLength = this.recipes.length;

    if (this.tabLength <= 0) {
      this.noRecipes = true;
    } else {
      this.noRecipes = false;
    }

    for (let i = 0; i < this.tabLength; i++) {
      this.recipeTabs.push({ id: this.recipes[i].id, name: this.recipes[i].name, type_id: this.recipes[i].type_id });
      this.recipes[i].lotSize = 1;
    }

    for (let i = 0; i < this.materials.length; i++) {
      this.materialDict[this.materials[i].id] = this.materials[i].name;
      this.materialUnitDict[this.materials[i].id] = this.materials[i].materialunit_id;
      this.materialPriceDict[this.materials[i].id] = this.materials[i].price;
      this.materialDensityDict[this.materials[i].id] = this.materials[i].density;
    }

    for (let i = 0; i < this.reciperesources.length; i++) {
      this.reciperesourcesDict[this.reciperesources[i].id] = this.reciperesources[i];
    }

    for (let i = 0; i < this.recipematerials.length; i++) {
      this.recipematerialsDict[this.recipematerials[i].id] = this.recipematerials[i];
    }

    for (let i = 0; i < this.recipecostings.length; i++) {
      this.recipeCostingDict[this.recipecostings[i].id] = this.recipecostings[i];
    }

    for (let i = 0; i < this.recipecategory.length; i++) {
      this.categoryDict[this.recipecategory[i].id] = this.recipecategory[i].name;
    }

    for (let i = 0; i < this.recipes.length; i++) {
      for (let j = 0; j < this.recipes[i].reciperesources.length; j++) {

        let index = this.catagoryArray.findIndex(x => x.id == Number([this.reciperesourcesDict[this.recipes[i].reciperesources[j].id].category_id]));
        if (index == -1) {
          // this.catagoryArray.push(Number([this.reciperesourcesDict[this.recipes[i].reciperesources[j].id].category_id]));
          this.catagoryArray.push({ id: Number([this.reciperesourcesDict[this.recipes[i].reciperesources[j].id].category_id]), lotSize: 1, lotCost: 0, unitCost: 0, NREcost: 0, SectionTotalCost: 0 });
        }
      }
      if (this.catagoryArray.length > 0) {
        this.recipeCategoryDict[this.recipes[i].id] = this.catagoryArray;
        this.catagoryArray = [];
      }
    }

    for (let i = 0; i < this.recipeType.length; i++) {
      this.recipetypeDict[this.recipeType[i].id] = this.recipeType[i].name;
    }

    for (let i = 0; i < this.owners.length; i++) {
      this.ownersDict[this.owners[i].id] = this.owners[i].firstname + ' ' + this.owners[i].lastname;
    }

    for (let i = 0; i < this.recipes.length; i++) {
      for (let j = 0; j < this.recipes[i].reciperesources.length; j++) {
        for (let k = 0; k < this.recipes[i].reciperesources[j].recipecostings.length; k++) {
          let cost = this.recipeCostingDict[this.recipes[i].reciperesources[j].recipecostings[k].id].cost;
          let measure = this.recipeCostingDict[this.recipes[i].reciperesources[j].recipecostings[k].id].measure;
          let burden = this.recipeCostingDict[this.recipes[i].reciperesources[j].recipecostings[k].id].burden;

          let timeunit = this.costtypeunitsDict[this.recipeCostingDict[this.recipes[i].reciperesources[j].recipecostings[k].id].costtypeunit_id];

          // if(measure == 0)
          //  measure = 1;
          let extendedcost = (cost * measure) * (1 + (burden / 100));

          this.recipeCostingDict[this.recipes[i].reciperesources[j].recipecostings[k].id]['extendedCost'] = extendedcost;


        }
      }
    }

    for (let i = 0; i < this.recipes.length; i++) {
      let reciperating = this.recipes[i].rating;
      this.calculateStarRating(i, reciperating);
    }

    for (let i = 0; i < this.recipes.length; i++) {
      let allRecipeResourcesCategories = [];
      if (this.recipeCategoryDict[this.recipes[i].id]) {
        for (let k = 0; k < this.recipeCategoryDict[this.recipes[i].id].length; k++) {

          allRecipeResourcesCategories.push(this.recipeCategoryDict[this.recipes[i].id][k].id);
          for (let j = 0; j < this.recipes[i].reciperesources.length; j++) {
            if (this.reciperesourcesDict[this.recipes[i].reciperesources[j].id].category_id === this.recipeCategoryDict[this.recipes[i].id][k].id) {

              for (let l = 0; l < this.recipes[i].reciperesources[j].recipecostings.length; l++) {
                let extendedcost = this.recipeCostingDict[this.recipes[i].reciperesources[j].recipecostings[l].id].extendedCost;

                if (this.recipeCostingDict[this.recipes[i].reciperesources[j].recipecostings[l].id].costtype_id == 1) {
                  this.recipeCategoryDict[this.recipes[i].id][k].lotCost = this.recipeCategoryDict[this.recipes[i].id][k].lotCost + extendedcost;
                }

                if (this.recipeCostingDict[this.recipes[i].reciperesources[j].recipecostings[l].id].costtype_id == 2) {
                  this.recipeCategoryDict[this.recipes[i].id][k].unitCost = this.recipeCategoryDict[this.recipes[i].id][k].unitCost + extendedcost;
                }

                if (this.recipeCostingDict[this.recipes[i].reciperesources[j].recipecostings[l].id].costtype_id == 3) {
                  this.recipeCategoryDict[this.recipes[i].id][k].NREcost = this.recipeCategoryDict[this.recipes[i].id][k].NREcost + extendedcost;
                }

              }
            }
          }
        }
      }

      for (let m = 0; m < allRecipeResourcesCategories.length; m++) {
        let categoryid = allRecipeResourcesCategories[m];
        let index = Number(this.recipeCategoryDict[this.recipes[i].id].findIndex(x => x.id == categoryid));
        let lotSize = Number(this.recipeCategoryDict[this.recipes[i].id][index].lotSize);
        let lotCost = Number(this.recipeCategoryDict[this.recipes[i].id][index].lotCost);
        let unitCost = Number(this.recipeCategoryDict[this.recipes[i].id][index].unitCost);
        let NREcost = Number(this.recipeCategoryDict[this.recipes[i].id][index].NREcost);

        // unitCost = unitCost + (lotCost/lotSize) + (NREcost/ lotSize);
        // var totalCost = unitCost * lotSize;
        let totalCost = unitCost + lotCost + NREcost;

        this.recipeCategoryDict[this.recipes[i].id][index].unitCost = Number(unitCost);
        this.recipeCategoryDict[this.recipes[i].id][index].SectionTotalCost = Number(totalCost);
      }

      allRecipeResourcesCategories = [];
    }

    let updatesumary = false;
    if (this.currentrecipeIndex === 0 || this.currentrecipeIndex) {
      updatesumary = true;
    }

    if (updatesumary) {
      this.calculateSummary(this.currentrecipeIndex, true);

    }

    let categoryLotCosting = {};

    this.recipeResourceCosting = {};
    let recipeResourceLotCostDict = {};

    this.loadingRecipes = false;
  }

  getMaterials() {
    this.recipesService.getMaterials()
      .subscribe(
      data => {
        let result = JSON.parse(data);
        this.materials = result.materials;

        for (let i = 0; i < this.materials.length; i++) {
          this.materialDict[this.materials[i].id] = this.materials[i].name;
          this.materialUnitDict[this.materials[i].id] = this.materials[i].materialunit_id;
          this.materialPriceDict[this.materials[i].id] = this.materials[i].price;
        }
      },
      error => {

      });
  }

  getMaterialShape() {
    this.recipesService.getMaterialShapes()
      .subscribe(
      data => {
        let result = JSON.parse(data);
        this.materialshapes = result.results;

        for (let i = 0; i < this.materialshapes.length; i++) {
          this.materialshapeDict[this.materialshapes[i].id] = this.materialshapes[i].name;
        }
      },
      error => {

      });
  }

  getMaterialsUnit() {
    this.recipesService.getMaterialUnits()
      .subscribe(
      data => {
        let result = JSON.parse(data);
        this.materialunits = result;
      },
      error => {

      });
  }

  refreshResources() {

    this.resources = null;
    this.categories = [];
    this.locations = [];
    this.costtypes = null;
    this.costtypeunits = null;
    this.costings = null;
    this.addnewCosting = {};
    this.recipesService.getResources()
      .subscribe(
      data => {

        console.log('Got resources');
        let jsondata = JSON.parse(data);

        this.resources = jsondata.resources;
        console.log('RESOURCES:', this.resources);

        this.categories = jsondata.categories;

        for (let i = 0; i < this.categories.length; i++) {
          this.categoriesDict[this.categories[i].id] = this.categories[i].name;
          this.categoryIndexToIDDict[this.categories[i].id] = i + 1;
        }

        this.locations = jsondata.locations;

        for (let i = 0; i < this.locations.length; i++) {
          this.locationDict[this.locations[i].id] = this.locations[i].name;
        }

        this.costtypes = jsondata.costtypes;
        for (let i = 0; i < this.costtypes.length; i++) {
          this.costingtypeDict[this.costtypes[i].id] = this.costtypes[i].name;
        }
        this.costtypeunits = jsondata.costtypeunits;
        this.costtypeunits = this.costtypeunits.slice().reverse();
        for (let i = 0; i < this.costtypeunits.length; i++) {
          this.costtypeunitsDict[this.costtypeunits[i].id] = this.costtypeunits[i].name;
        }
        this.costings = jsondata.costings;

      },
      error => {
        this.loadingResources = false;
      });
  }

  getReciperesource() {

    this.recipesService.getReciperesource()
      .subscribe(
      data => {
        let result = JSON.parse(data);
        this.recipeResources = result.results;
      },
      error => {

      });
  }

  getRecipecostings() {

    this.recipesService.getRecipecosting()
      .subscribe(
      data => {
        let result = JSON.parse(data);
        this.recipecostingsDict = {};
        this.recipecostings = result.results;
        let costingsArray = [];

        let valuegot = false;

        for (let i = 0; i < this.recipeResources.length; i++) {
          for (let j = 0; j < this.recipecostings.length; j++) {

            if (this.recipecostings[j].reciperesource_id == this.recipeResources[i].id) {

              for (let k = 0; k < this.costtypes.length; k++) {
                if (this.costtypes[k].id == this.recipecostings[j].costtype_id) {
                  costingsArray.push({ id: this.costtypes[k].id, name: this.costtypes[k].name });
                  valuegot = true;
                }
              }
            }
            // this.recipecostingsDict[this.recipecostings[i].id] = this.recipecostings[i];
          }
          if (valuegot) {
            console.log('Costing array', costingsArray);
            this.recipecostingsDict[this.recipeResources[i].id] = costingsArray;
            costingsArray = [];
            valuegot = false;
          }
        }

        console.log('Costing array', this.recipecostingsDict);

      },
      error => {
      });

  }

  getSpecifiedReciperesource() {
    let resourceinfo = {};
    // for(let i = 0;  i < this.recipes.length;  i++) {
    for (let i = 0; i < this.recipes[0].reciperesources.length; i++) {

      let recipeResourcesid = this.recipes[0].reciperesources[i];

      this.recipesService.getSpecifiedReciperesource(recipeResourcesid)
        .subscribe(
        data => {
          let result = JSON.parse(data);
          result = result.results;
          if (!result) {
            return;
          }
          let resourceid = result.resource_id;
          let categoryid = result.category_id;
          console.log('resource : ', result);

          for (let j = 0; j < this.categories.length; j++) {
            if (this.categories[j].id === categoryid) {
              let category = this.categories[j];
              category.respected_resourceid = resourceid;
              let entryadded = false;
              if (this.tabcategories) {
                for (let k = 0; k < this.tabcategories.length; k++) {
                  if (this.tabcategories[k].id == categoryid) {
                    this.tabcategories[k].respected_resourceid.push(resourceid);
                    entryadded = true;
                  }
                }
                if (!entryadded) {
                  this.tabcategories.push({
                    id: category.id, enabled: category.enabled,
                    name: category.name, respected_resourceid: [category.respected_resourceid]
                  });
                }
              } else {
                this.tabcategories.push({
                  id: category.id, enabled: category.enabled,
                  name: category.name, respected_resourceid: [category.respected_resourceid]
                });
              }
              console.log('tab categories id added : ', this.tabcategories);
            }
          }
          // this.recipesService.getSpecifiedResources(resourceid)
          // .subscribe(
          //   data => {
          //     let resourceresults = JSON.parse(data);
          //     console.log('resource : ', resourceresults);
          //   },
          //   error => {

          //   });
        },
        error => {

        });
    }
    // }
  }

  getResourcesCategory() {

    this.recipesService.getResourcesCategory()
      .subscribe(
      data => {
        console.log('Got ResourcesCategory:');
        console.log('data');
        let result = JSON.parse(data);
        this.categories = result.results;
      },
      error => {

      });
  }

  getTemplate() {

    this.loadingRecipes = true;
    this.recipesService.getRecipeTemplate()
      .subscribe(
      data => {
        console.log('Got Recipes template');
        let result = JSON.parse(data);
        this.recipeTemplates = result.results;
      },
      error => {

      });
  }

  getRecipeType() {
    this.loadingRecipes = true;
    this.recipesService.getRecipeType()
      .subscribe(
      data => {
        console.log('Got Recipe Type');
        let result = JSON.parse(data);
        this.recipeTemplates = result.results;
      },
      error => {
      });
  }

  /**
  * Create New Recipe in MR2 Database
  * Calls addRecipe service with to create new Recipe in the database.
  *
  * @return void
  */
  createNewRecipe(newrecipe: any) {

    this.waiticon = 'fa right fa-spinner fa-pulse';

    this.recipesService.addRecipe(newrecipe).subscribe(
      data => {
        try {
          if (Number(data)) {
            this.waiticon = '';

            this.getRecipe(this.recipeProjectid);

            Materialize.toast('RECIPE ' + newrecipe.name + ' CREATED SUCCESSFULLY', 1500);
            console.log('RECIPE newrecipeName CREATED SUCCESSFULLY');
            this.modalNewRecipeAction.emit({ action: 'modal', params: ['close'] });
          } else {
            Materialize.toast('RECIPE IS ALREADY PRESENT. PLEASE TRY AGAIN WITH ANOTHER CATEGORY NAME.', 1500);
            console.log('RECIPE IS ALREADY PRESENT. PLEASE TRY AGAIN WITH ANOTHER CATEGORY NAME.');
            this.waiticon = '';
          }
        } catch (e) {
          console.log('INTERNAL ERROR WHILE ADDING RECIPE: ' + e);
          Materialize.toast('INTERNAL  ERROR WHILE ADDING RECIPE.', 1500);
          this.waiticon = '';
        }
      },
      error => {
        console.log('INTERNAL ERROR WHILE ADDING RECIPE NAME : ' + error);
        Materialize.toast('INTERNAL ERROR WHILE ADDING RECIPE NAME.', 1500);
        this.waiticon = '';
      });

  }

  /**
  * Create New Recipe in MR2 Database
  * Calls addRecipe service with to create new Recipe in datbase.
  *
  * @return void
  */
  updateRecipe(updatedRecipe: any, index, recipe: any) {

    document.getElementById('recipeApply' + index).style.display = 'none';
    document.getElementById('recipeCancel' + index).style.display = 'none';
    document.getElementById('recipeApplyloading' + index).style.display = 'block';

    this.recipesService.updateRecipe(updatedRecipe).subscribe(
      data => {
        try {
          let json = JSON.parse(data);
          if (json == true) {
            // this.refreshRecipes()
            Materialize.toast('RECIPE ' + updatedRecipe.name + ' UPDATED SUCCESSFULLY', 1500);
            console.log('RECIPE UPDATED SUCCESSFULLY.');
            this.SaveRowChangesInUI(updatedRecipe, index, recipe);
          } else {
            console.log('INTERNAL ERROR WHILE UPDATING RECIPE: ');
            Materialize.toast('INTERNAL ERROR WHILE UPDATING RECIPE.', 1500);
          }
        } catch (e) {
          console.log('INTERNAL ERROR WHILE UPDATING RECIPE: ' + e);
          Materialize.toast('INTERNAL ERROR WHILE UPDATING RECIPE.', 1500);
        }
      },
      error => {
        console.log('INTERNAL ERROR WHILE UPDATING RECIPE NAME : ' + error);
        Materialize.toast('INTERNAL ERROR WHILE UPDATING RECIPE NAME.', 1500);

      });
  }

  toValues(values) {
    this.lotSize = values;
  }
  openmodalNewTemplate() {

    this.modalNewTemplateAction.emit({ action: 'modal', params: ['open'] });
  }
  openmodalRecipeDetails() {
    this.modalRecipeDetailsAction.emit({ action: 'modal', params: ['open'] });
  }
  openmodalAddActivity() {
    this.modalAddActivityAction.emit({ action: 'modal', params: ['open'] });
    this.addActivityButtonStatus = false;
  }
  // openmodalAddCategory() {
  //   this.modalAddCategoryAction.emit({ action: 'modal', params: ['open'] });
  // }
  createAddCategorySubmit() {
    // this function was called in the html template but is missing from the component
  }
  openNewRecipeModal() {
    (<HTMLInputElement>document.getElementById('estimateRecipe')).checked = true;
    (<HTMLInputElement>document.getElementById('recipeName')).value = '';
    this.modalNewRecipeAction.emit({ action: 'modal', params: ['open'] });
  }
  removeRecipe(recipe: any, index: number) {

    this.selectedRecipe = recipe;
    this.currentTabIndex = index;
    this.modalConfirmRemoveRecipeAction.emit({ action: 'modal', params: ['open'] });

  }


  RemoveRecipeConfirm() {

    this.waiticon = 'fa right fa-spinner fa-pulse';

    this.recipesService.removeRecipe(this.selectedRecipe.id).subscribe(
      data => {
        try {
          let json = JSON.parse(data);

          if (json == true) {
            this.waiticon = '';
            Materialize.toast('RECIPE ' + this.selectedRecipe.name + ' REMOVED SUCCESSFULLY.', 1500);
            console.log('RECIPE REMOVED SUCCESSFULLY.');
            this.modalConfirmRemoveRecipeAction.emit({ action: 'modal', params: ['close'] });

            this.recipes.splice(this.currentTabIndex, 1);
            this.updateAllVariables();

          } else {
            console.log('INTERNAL ERROR WHILE REMOVING RECIPE');
            Materialize.toast('INTERNAL ERROR WHILE REMOVING RECIPE .', 1500);
            this.waiticon = '';
          }
        } catch (e) {
          console.log('INTERNAL ERROR WHILE REMOVING RECIPE .');
          Materialize.toast('INTERNAL ERROR WHILE REMOVING RECIPE .', 1500);
          this.waiticon = '';
        }
      },
      error => {
        console.log('INTERNAL ERROR WHILE REMOVING RECIPE .');
        Materialize.toast('INTERNAL ERROR WHILE REMOVING RECIPE .', 1500);
        this.waiticon = '';
      });

  }

  removeRecipeResource(recipeIndex: number, recipeResource: any, recipeCategory: number, recipeResourceIndex: number) {

    this.currentRecipeResource = recipeResource;
    this.currentRecipeCategory = recipeCategory;
    this.currentrecipeIndex = recipeIndex;
    this.currentrecipeResourceIndex = recipeResourceIndex;
    this.modalConfirmRemoveRecipeResourceAction.emit({ action: 'modal', params: ['open'] });
  }

  RemoveRecipeResourceConfirm() {

    this.waiticon = 'fa right fa-spinner fa-pulse';

    this.recipesService.removeRecipeResource(this.currentRecipeResource.id).subscribe(
      data => {
        try {
          let json = JSON.parse(data);

          if (json == true) {
            this.waiticon = '';
            Materialize.toast('RECIPE RESOURCE ' + this.currentRecipeResource.name + ' REMOVED SUCCESSFULLY.', 1500);
            console.log('RECIPE RESOURCE REMOVED SUCCESSFULLY.');
            this.modalConfirmRemoveRecipeResourceAction.emit({ action: 'modal', params: ['close'] });

            this.recipes[this.currentrecipeIndex].reciperesources.splice(this.currentrecipeResourceIndex, 1);
            this.updateAllVariables();


          } else {
            console.log('INTERNAL ERROR WHILE REMOVING RECIPE RESOURECE.');
            Materialize.toast('INTERNAL ERROR WHILE REMOVING RECIPE RESOURECE.', 1500);
            this.waiticon = '';
          }
        } catch (e) {
          console.log('INTERNAL ERROR WHILE REMOVING RECIPE RESOURECE.');
          Materialize.toast('INTERNAL ERROR WHILE REMOVING RECIPE RESOURECE.', 1500);
          this.waiticon = '';
        }
      },
      error => {
        console.log('INTERNAL ERROR WHILE REMOVING RECIPE RESOURECE.');
        Materialize.toast('INTERNAL ERROR WHILE REMOVING RECIPE RESOURECE.', 1500);
        this.waiticon = '';
      });

  }


  editRecipeRow(recipe, index) {

    document.getElementById('recipename' + index).style.display = 'none';
    document.getElementById('recipenameEdit' + index).style.display = 'block';

    document.getElementById('recipenote' + index).style.display = 'none';
    document.getElementById('recipenoteEdit' + index).style.display = 'block';

    document.getElementById('recipetype' + index).style.display = 'none';
    document.getElementById('recipetypeEdit' + index).style.display = 'block';

    document.getElementById('reciperating' + index).style.display = 'none';
    document.getElementById('reciperatingEdit' + index).style.display = 'block';

    document.getElementById('recipeDefault' + index).style.display = 'none';
    document.getElementById('recipeDefaultEdit' + index).style.display = 'block';

    document.getElementById('recipePencil' + index).style.display = 'none';
    document.getElementById('recipeApply' + index).style.display = 'block';
    document.getElementById('recipeCancel' + index).style.display = 'block';
    document.getElementById('recipeDropDownIcon' + index).style.display = 'none';
  }

  saveRecipeRow(index, recipe: any) {

    let rating = Number((<HTMLInputElement>document.getElementById('reciperatingSelectEdit' + index)).value);
    let defaultSelectElement = <HTMLSelectElement>document.getElementById('recipeDefaultSelectEdit' + index);
    let is_default = Number(defaultSelectElement.options[defaultSelectElement.selectedIndex].value);
    console.log('is_default:', is_default);

    if (is_default == 1) {
      for (let key in this.recipes) {
        if (this.recipes.hasOwnProperty(key)) {
          if (recipe.id === this.recipes[key].id) {
            this.recipes[key].is_default = 1;
          } else {
            this.recipes[key].is_default = 0;
          }
        }
      }
    }

    let updatedRecipe = {
      id: recipe.id,
      is_default: is_default,
      name: (<HTMLInputElement>document.getElementById('recipenameEdit' + index)).value,
      note: (<HTMLInputElement>document.getElementById('recipenoteEdit' + index)).value,
      type_id: Number((<HTMLInputElement>document.getElementById('recipetypeEditSelect' + index)).value),
      rating: rating,
      project_id: recipe.project_id
    };

    if (updatedRecipe.name.length <= 0) {
      Materialize.toast('RECIPE NAME IS REQUIRED', 1500);
      console.log('RECIPE NAME IS REQUIRED.');
      return;
    }

    this.updateRecipe(updatedRecipe, index, recipe);
  }

  SaveRowChangesInUI(updatedRecipe, index, recipe: any) {
    recipe.name = updatedRecipe.name;
    recipe.note = updatedRecipe.note;
    recipe.type_id = updatedRecipe.type_id;
    recipe.rating = updatedRecipe.rating;
    recipe.enabled = updatedRecipe.enabled;
    // recipetypeDict[recipe.type_id]
    // (<HTMLInputElement>document.getElementById('recipeStatusSelectEdit')).value = "abc";
    // recipetypeDict[recipe.type_id]

    this.calculateStarRating(index, recipe.rating);

    this.endRecipeRowEditMode(index);
  }

  cancelRecipeRow(index) {
    this.endRecipeRowEditMode(index);
  }

  endRecipeRowEditMode(index) {
    document.getElementById('recipename' + index).style.display = 'block';
    document.getElementById('recipenameEdit' + index).style.display = 'none';
    document.getElementById('recipenote' + index).style.display = 'block';
    document.getElementById('recipenoteEdit' + index).style.display = 'none';
    document.getElementById('recipetype' + index).style.display = 'block';
    document.getElementById('recipetypeEdit' + index).style.display = 'none';
    document.getElementById('recipeDefault' + index).style.display = 'block';
    document.getElementById('recipeDefaultEdit' + index).style.display = 'none';
    document.getElementById('reciperating' + index).style.display = 'block';
    document.getElementById('reciperatingEdit' + index).style.display = 'none';

    document.getElementById('recipePencil' + index).style.display = 'block';
    document.getElementById('recipeApply' + index).style.display = 'none';
    document.getElementById('recipeApplyloading' + index).style.display = 'none';
    document.getElementById('recipeCancel' + index).style.display = 'none';
    document.getElementById('recipeDropDownIcon' + index).style.display = 'block';
  }

  openEditSectionActivityModal(rowNumber: number, recipe: any, categoryId: number) {

    document.getElementById('categoryEdit' + rowNumber + recipe.id).style.display = 'none';
    document.getElementById('categoryAdd' + rowNumber + recipe.id).style.display = 'none';
    document.getElementById('categoryApply' + rowNumber + recipe.id).style.display = 'inline-block';
    document.getElementById('categoryCancel' + rowNumber + recipe.id).style.display = 'inline-block';

    let index = 0;
    for (let recipeResource of recipe.reciperesources) {

      if (this.reciperesourcesDict[recipeResource.id].category_id == categoryId) {

        document.getElementById('recipeResdescription' + index + rowNumber + recipe.id).style.display = 'none';
        document.getElementById('recipeResdescriptionValueEdit' + index + rowNumber + recipe.id).style.display = 'block';

        for (let k = 0; k < recipeResource.recipecostings.length; k++) {
          document.getElementById('recipedescription' + index + rowNumber + recipe.id + k).style.display = 'none';
          document.getElementById('recipedescriptionValueEdit' + index + rowNumber + recipe.id + k).style.display = 'block';

          document.getElementById('recipecost' + index + rowNumber + recipe.id + k).style.display = 'none';
          document.getElementById('recipecostValueEdit' + index + rowNumber + recipe.id + k).style.display = 'block';

          document.getElementById('recipemeasure' + index + rowNumber + recipe.id + k).style.display = 'none';
          document.getElementById('recipemeasureValueEdit' + index + rowNumber + recipe.id + k).style.display = 'block';

          document.getElementById('recipeburden' + index + rowNumber + recipe.id + k).style.display = 'none';
          document.getElementById('recipeburdenValueEdit' + index + rowNumber + recipe.id + k).style.display = 'block';
        }
        document.getElementById('recipeRemove' + index + rowNumber + recipe.id).style.display = 'none';
      }
      index++;
    }



  }

  saveRecipeResourceEdit(rowNumber: number, recipe: any, categoryId: number) {

    this.endRecipeResourceEdit(rowNumber, recipe, categoryId);
  }


  cancelRecipeResourceEdit(rowNumber: number, recipe: any, categoryId: number) {


    this.endRecipeResourceEdit(rowNumber, recipe, categoryId);
  }

  endRecipeResourceEdit(rowNumber: number, recipe: any, categoryId: number) {
    let EditedrecipeResource: any = {};
    let recipeResourceID: Number;
    let toasterShown = true;

    let index = 0;
    let localupdatedindex = 0;
    let i = 0;
    for (let recipeResource of recipe.reciperesources) {
      i = index;
      if (this.reciperesourcesDict[recipeResource.id].category_id == categoryId) {

        EditedrecipeResource[i] = {};
        EditedrecipeResource[i]['reciperesource'] = {};
        recipeResourceID = recipeResource.id;

        document.getElementById('recipeResdescription' + index + rowNumber + recipe.id).style.display = 'block';
        document.getElementById('recipeResdescriptionValueEdit' + index + rowNumber + recipe.id).style.display = 'none';
        EditedrecipeResource[i].reciperesource['description'] = (<HTMLInputElement>document.getElementById('recipeResdescriptionValueEdit' + index + rowNumber + recipe.id)).value;
        this.reciperesourcesDict[recipeResource.id].description = (<HTMLInputElement>document.getElementById('recipeResdescriptionValueEdit' + index + rowNumber + recipe.id)).value;

        EditedrecipeResource[i]['recipecosting'] = [];

        for (let k = 0; k < recipeResource.recipecostings.length; k++) {

          document.getElementById('recipedescription' + index + rowNumber + recipe.id + k).style.display = 'block';
          document.getElementById('recipedescriptionValueEdit' + index + rowNumber + recipe.id + k).style.display = 'none';
          this.recipeCostingDict[recipeResource.recipecostings[k].id].description = (<HTMLInputElement>document.getElementById('recipedescriptionValueEdit' + index + rowNumber + recipe.id + k)).value;

          document.getElementById('recipecost' + index + rowNumber + recipe.id + k).style.display = 'block';
          document.getElementById('recipecostValueEdit' + index + rowNumber + recipe.id + k).style.display = 'none';
          this.recipeCostingDict[recipeResource.recipecostings[k].id].cost = (<HTMLInputElement>document.getElementById('recipecostValueEdit' + index + rowNumber + recipe.id + k)).value;

          document.getElementById('recipemeasure' + index + rowNumber + recipe.id + k).style.display = 'block';
          document.getElementById('recipemeasureValueEdit' + index + rowNumber + recipe.id + k).style.display = 'none';
          this.recipeCostingDict[recipeResource.recipecostings[k].id].measure = (<HTMLInputElement>document.getElementById('recipemeasureValueEdit' + index + rowNumber + recipe.id + k)).value;

          document.getElementById('recipeburden' + index + rowNumber + recipe.id + k).style.display = 'block';
          document.getElementById('recipeburdenValueEdit' + index + rowNumber + recipe.id + k).style.display = 'none';
          this.recipeCostingDict[recipeResource.recipecostings[k].id].burden = (<HTMLInputElement>document.getElementById('recipeburdenValueEdit' + index + rowNumber + recipe.id + k)).value;

          EditedrecipeResource[i].recipecosting.push({
            id: recipeResource.recipecostings[k].id, description: this.recipeCostingDict[recipeResource.recipecostings[k].id].description,
            cost: this.recipeCostingDict[recipeResource.recipecostings[k].id].cost, measure: this.recipeCostingDict[recipeResource.recipecostings[k].id].measure,
            burden: this.recipeCostingDict[recipeResource.recipecostings[k].id].burden
          });
        }

        document.getElementById('recipeRemove' + index + rowNumber + recipe.id).style.display = 'block';
      }

      if (EditedrecipeResource[i]) {
        this.recipesService.updateReciperesource(EditedrecipeResource[i], recipeResourceID)
          .subscribe(
          data => {
            console.log('data', data);
            localupdatedindex++;


            // if(index == localupdatedindex)
            if (toasterShown) {
               Materialize.toast('RESOURCE UPDATED SUCCESSFULLY', 1500);
               toasterShown = false;
            }

            // if(index == localupdatedindex){

            for (let l = 0; l < this.recipes.length; l++) {
              if (this.recipes[l].id == recipe.id) {
                for (let j = 0; j < recipe.reciperesources.length; j++) {
                  for (let k = 0; k < recipe.reciperesources[j].recipecostings.length; k++) {
                    let cost = this.recipeCostingDict[recipe.reciperesources[j].recipecostings[k].id].cost;
                    let measure = this.recipeCostingDict[recipe.reciperesources[j].recipecostings[k].id].measure;
                    let burden = this.recipeCostingDict[recipe.reciperesources[j].recipecostings[k].id].burden;
                    let timeunit = this.costtypeunitsDict[this.recipeCostingDict[recipe.reciperesources[j].recipecostings[k].id].costtypeunit_id];
                    // if(measure == 0)
                    //  measure = 1;
                    let extendedcost = (cost * measure) * (1 + (burden / 100));

                    this.recipeCostingDict[recipe.reciperesources[j].recipecostings[k].id]['extendedCost'] = extendedcost;


                  }
                }


                for (let i = 0; i < this.recipes.length; i++) {
                  // var allRecipeResourcesCategories = [];
                  if (this.recipeCategoryDict[this.recipes[i].id]) {
                    for (let k = 0; k < this.recipeCategoryDict[this.recipes[i].id].length; k++) {

                      this.recipeCategoryDict[this.recipes[i].id][k].lotCost = 0;
                      this.recipeCategoryDict[this.recipes[i].id][k].unitCost = 0;
                      this.recipeCategoryDict[this.recipes[i].id][k].NREcost = 0;

                      // allRecipeResourcesCategories.push(this.recipeCategoryDict[this.recipes[i].id][k].id);
                      for (let j = 0; j < this.recipes[i].reciperesources.length; j++) {
                        if (this.reciperesourcesDict[this.recipes[i].reciperesources[j].id].category_id === this.recipeCategoryDict[this.recipes[i].id][k].id) {
                          for (let l = 0; l < this.recipes[i].reciperesources[j].recipecostings.length; l++) {
                            let extendedcost = this.recipeCostingDict[this.recipes[i].reciperesources[j].recipecostings[l].id].extendedCost;

                            if (this.recipeCostingDict[this.recipes[i].reciperesources[j].recipecostings[l].id].costtype_id == 1) {
                              this.recipeCategoryDict[this.recipes[i].id][k].lotCost = this.recipeCategoryDict[this.recipes[i].id][k].lotCost + extendedcost;
                            }

                            if (this.recipeCostingDict[this.recipes[i].reciperesources[j].recipecostings[l].id].costtype_id == 2) {
                              this.recipeCategoryDict[this.recipes[i].id][k].unitCost = this.recipeCategoryDict[this.recipes[i].id][k].unitCost + extendedcost;
                            }

                            if (this.recipeCostingDict[this.recipes[i].reciperesources[j].recipecostings[l].id].costtype_id == 3) {
                              this.recipeCategoryDict[this.recipes[i].id][k].NREcost = this.recipeCategoryDict[this.recipes[i].id][k].NREcost + extendedcost;
                            }

                          }

                          let lotSize = Number(this.recipeCategoryDict[this.recipes[i].id][k].lotSize);
                          let lotCost = Number(this.recipeCategoryDict[this.recipes[i].id][k].lotCost);
                          let unitCost = Number(this.recipeCategoryDict[this.recipes[i].id][k].unitCost);
                          let NREcost = Number(this.recipeCategoryDict[this.recipes[i].id][k].NREcost);

                          let totalCost = unitCost + lotCost + NREcost;

                          this.recipeCategoryDict[this.recipes[i].id][k].SectionTotalCost = Number(totalCost);
                        }
                      }
                    }
                  }
                }
                this.calculateSummary(l, true);
              }
            }
          },
          error => {
          });
      }
      index++;
    }

    document.getElementById('categoryEdit' + rowNumber + recipe.id).style.display = 'inline-block';
    document.getElementById('categoryAdd' + rowNumber + recipe.id).style.display = 'inline-block';
    document.getElementById('categoryApply' + rowNumber + recipe.id).style.display = 'none';
    document.getElementById('categoryCancel' + rowNumber + recipe.id).style.display = 'none';
  }

  openAddActivityModal(category: any, tabcategories: any) {


    if (category) {
      (<HTMLInputElement>document.getElementById('resourceSelectedCategoryId')).value = category;
    } else {
      (<HTMLInputElement>document.getElementById('resourceSelectedCategoryId')).value = this.categories[0].id;
    }
    this.resourceSelectedCategoryIdChange();
    this.modalAddActivityAction.emit({ action: 'modal', params: ['open'] });
  }

  openConfirmRemoveCategoryModal(user) {
    // this function was called in the html template but is missing from the component
    console.log('Need to update this function ', + user);
  }
  openNewTemplateModal(recipe) {
    // this function was called in the html template but is missing from the component
    this.selectedRecipe = recipe;
    // this.currentTabIndex = index;

    this.modalNewTemplateAction.emit({ action: 'modal', params: ['open'] });
    console.log('Need to update this function ');
  }

  createNewRecipeSubmit() {

    let actualRecipeInput: boolean = (<HTMLInputElement>document.getElementById('actualRecipe')).checked;
    let typeid: Number = 1;

    if (actualRecipeInput) {
      typeid = 2;
    }

    let template_id = Number((<HTMLInputElement>document.getElementById('recipeSelectedTemplateId')).value);
    let selectedindex = (<HTMLSelectElement>document.getElementById('recipeSelectedTemplateId')).selectedIndex;

    let newrecipe = {
      type_id: typeid,
      name: (<HTMLInputElement>document.getElementById('recipeName')).value,
      template_id: template_id,
      template_name: this.recipeTemplates[selectedindex].name,
      project_id: this.recipeProjectid
    };

    if (newrecipe.name.length <= 0) {
      Materialize.toast('RECIPE NAME IS REQUIRED', 1500);
      console.log('RECIPE NAME IS REQUIRED');
      return;
    }

    this.createNewRecipe(newrecipe);
  }

  createNewTemplateSubmit() {
    // this function was called in the html template but is missing from the component
    this.waiticon = 'fa right fa-spinner fa-pulse';
    let templateName = (<HTMLInputElement>document.getElementById('templateName')).value;
    console.log('templateName : ', templateName);

    let recipeIdArays = [];
    for (let i = 0; i < this.selectedRecipe.reciperesources.length; i++) {
      recipeIdArays.push(this.selectedRecipe.reciperesources[i].id);
    }

    this.recipesService.addNewRecipeTemplate(templateName, templateName, recipeIdArays).
      subscribe(
      data => {
        console.log('New Template Created : ', data);
        this.waiticon = '';
        Materialize.toast('RECIPE SAVED AS TEMPLATE.', 1000);
        this.modalNewTemplateAction.emit({ action: 'modal', params: ['close'] });
        // this.getTemplate();
      },
      error => {
        console.log(' Error on new template creation', error);
      }
      );
  }

  addToRecipeResourceArray(resource: any, index: number) {
    this.checkedIndexes.push(index);
    if ((<HTMLInputElement>document.getElementById('resourceSelectedCategoryIdcheckbox' + index)).checked) {
      this.newrecipeResourcesDict[index] = resource;
      this.newrecipeResourcesLength++;
    } else {
      this.newrecipeResourcesDict[index] = undefined;
      this.newrecipeResourcesLength--;
    }

    // Category select drop-down & ADD button disabled logic
    if (this.newrecipeResourcesLength >= 1) {
      this.addActivityButtonStatus = false;
      this.changeCategorySelectStatus = true;
      } else {
      this.addActivityButtonStatus = true;
      this.changeCategorySelectStatus = false;
      }
  }

  activityUILocalUpdate() {

  }

  createAddActivitySubmit() {

    this.waiticon = 'fa fa-spinner fa-pulse left';
    let counter = 0;

    for (let recipeResources in this.newrecipeResourcesDict) {

      if (this.newrecipeResourcesDict[Number(recipeResources)] != undefined) {

        this.recipesService.addReciperesource(this.newrecipeResourcesDict[Number(recipeResources)], this.selectedRecipe.id).subscribe(
          data => {
            try {
              counter++;

              if (Number(data)) {
                Materialize.toast('RECIPE RESOURCE ' + this.newrecipeResourcesDict[Number(recipeResources)].name + ' ADDED SUCCESSFULLY', 1500);
                console.log('RECIPE RESOURCE ADDED SUCCESSFULLY.');

                if (this.newrecipeResourcesLength == counter) {
                  this.waiticon = '';
                  this.newrecipeResourcesLength = 0;
                  this.newrecipeResourcesDict = {};
                  this.modalAddActivityAction.emit({ action: 'modal', params: ['close'] });
                  this.addActivityButtonStatus = true;
                  this.changeCategorySelectStatus = false;
                  this.getRecipe(this.recipeProjectid);
                }

                for (let i = 0; i < this.checkedIndexes.length; i++) {
                  (<HTMLInputElement>document.getElementById('resourceSelectedCategoryIdcheckbox' + this.checkedIndexes[i])).checked = false;
                }
                this.checkedIndexes = [];

              } else {
                console.log('INTERNAL ERROR 1 WHILE ADDING RECIPE RESOURCE: ');
                Materialize.toast('INTERNAL ERROR WHILE ADDING RECIPE RESOURCE', 1500);
                for (let i = 0; i < this.checkedIndexes.length; i++) {
                  (<HTMLInputElement>document.getElementById('resourceSelectedCategoryIdcheckbox' + this.checkedIndexes[i])).checked = false;
                  this.newrecipeResourcesDict = {};
                  this.newrecipeResourcesLength = 0;
                }
                this.checkedIndexes = [];
                this.waiticon = '';
              }
            } catch (e) {
              console.log('INTERNAL ERROR 2 WHILE ADDING RECIPE RESOURCE: ');
              Materialize.toast('INTERNAL ERROR WHILE ADDING RECIPE RESOURCE', 1500);
              console.log('===>checkedIndexes.length<=== : ', this.checkedIndexes.length);
              for (let i = 0; i < this.checkedIndexes.length; i++) {
                (<HTMLInputElement>document.getElementById('resourceSelectedCategoryIdcheckbox' + this.checkedIndexes[i])).checked = false;
                this.newrecipeResourcesDict = {};
                this.newrecipeResourcesLength = 0;
              }
              this.checkedIndexes = [];
              this.waiticon = '';
            }
          },
          error => {
            console.log('INTERNAL ERROR 3 WHILE ADDING RECIPE RESOURCE: ');
            Materialize.toast('INTERNAL ERROR WHILE ADDING RECIPE RESOURCE', 1500);
            this.waiticon = '';
          });
      }
    }
  }

  cancelAddActivity() {
    // need to empty the check boxes upon cancelling the add activity step modal
    if (this.newrecipeResourcesLength >= 1) {
      for (let i = 0; i < this.checkedIndexes.length; i++) {
        (<HTMLInputElement>document.getElementById('resourceSelectedCategoryIdcheckbox' + this.checkedIndexes[i])).checked = false;
      }
      this.newrecipeResourcesLength = 0;
      this.newrecipeResourcesDict = {};
      this.checkedIndexes = [];
    }
    this.modalAddActivityAction.emit({ action: 'modal', params: ['close'] });
  }


  cancelCreateAddCategory() {
    // this function was called in the html template but is missing from the component
    console.log('Need to update this function ');
  }

  editMaterialRow(recipeId: number) {

    document.getElementById('materialname' + recipeId).style.display = 'none';
    document.getElementById('materialnameEdit' + recipeId).style.display = 'block';

    document.getElementById('stocksize' + recipeId).style.display = 'none';
    document.getElementById('stocksizeEdit' + recipeId).style.display = 'block';

    document.getElementById('shape' + recipeId).style.display = 'none';
    document.getElementById('shapeEdit' + recipeId).style.display = 'block';

    document.getElementById('mtrlCostperUnit' + recipeId).style.display = 'none';
    document.getElementById('mtrlCostperUnitEdit' + recipeId).style.display = 'block';

    document.getElementById('mtrlExtras' + recipeId).style.display = 'none';
    document.getElementById('mtrlExtrasEdit' + recipeId).style.display = 'block';

    document.getElementById('mtrlMarkUp' + recipeId).style.display = 'none';
    document.getElementById('mtrlMarkUpEdit' + recipeId).style.display = 'block';

    document.getElementById('cost_each' + recipeId).style.display = 'none';
    document.getElementById('cost_eachEdit' + recipeId).style.display = 'block';

    document.getElementById('materialpencil' + recipeId).style.display = 'none';
    document.getElementById('materialapply' + recipeId).style.display = 'inline-block';
    document.getElementById('materialcancel' + recipeId).style.display = 'inline-block';
    // document.getElementById('removeMaterial').style.display = 'none';

    this.materialselect = this.recipeMaterials['material_id'];
    this.materialshapeselect = this.recipeMaterials['materialshape_id'];
  }

  onMaterialChange(value) {
    console.log('material value', value);
    this.materialselect = value;
    this.materialshapeselect = null;

    if (JSON.stringify(this.previousMaterialRecipeResource) === '{}') {
      this.previousMaterialRecipeResource['material_id'] = this.recipeMaterials['material_id'];
      this.previousMaterialRecipeResource['materialunit_id'] = this.recipeMaterials['materialunit_id'];
      this.previousMaterialRecipeResource['stock_size_length'] = this.recipeMaterials['stock_size_length'];
      this.previousMaterialRecipeResource['stock_size_height'] = this.recipeMaterials['stock_size_height'];
      this.previousMaterialRecipeResource['stock_size_width'] = this.recipeMaterials['stock_size_width'];
      this.previousMaterialRecipeResource['price'] = this.recipeMaterials['price'];
      this.previousMaterialRecipeResource['markup'] = this.recipeMaterials['markup'];
      this.previousMaterialRecipeResource['extras'] = this.recipeMaterials['extras'];
      this.previousMaterialRecipeResource['density'] = this.recipeMaterials['density'];
      this.previousMaterialRecipeResource['cost_each'] = this.recipeMaterials['cost_each'];
    }

    let previousmaterialunitid = this.recipeMaterials['materialunit_id'];
    this.recipeMaterials['materialunit_id'] = this.materialUnitDict[value];

    if (this.recipeMaterials['materialunit_id'] != previousmaterialunitid) {
      if (previousmaterialunitid == 1) {
        this.recipeMaterials['stock_size_length'] = this.roundNumber(((this.recipeMaterials['stock_size_length']) * 25.4), 2);
        this.recipeMaterials['stock_size_height'] = this.roundNumber(((this.recipeMaterials['stock_size_height']) * 25.4), 2);
        this.recipeMaterials['stock_size_width'] = this.roundNumber(((this.recipeMaterials['stock_size_width']) * 25.4), 2);
        this.stocksizeInch_unit = false;
      } else {
        this.recipeMaterials['stock_size_length'] = this.roundNumber((this.recipeMaterials['stock_size_length'] / 25.4), 2);
        this.recipeMaterials['stock_size_height'] = this.roundNumber((this.recipeMaterials['stock_size_height'] / 25.4), 2);
        this.recipeMaterials['stock_size_width'] = this.roundNumber((this.recipeMaterials['stock_size_width'] / 25.4), 2);
        this.stocksizeInch_unit = true;
      }
    }
    this.recipeMaterials['material_id'] = value;
    this.recipeMaterials['price'] = this.materialPriceDict[value];
    this.recipeMaterials['density'] = this.materialDensityDict[value];
    this.recipeMaterials['markup'] = null;
    this.recipeMaterials['extras'] = null;
    this.recipeMaterials['cost_each'] = null;
  }

  onMaterialshapeChange(value) {
    console.log('materialshape value', value);
    this.materialshapeselect = value;
  }

  saveMaterialRow(recipeId: number) {
    console.log('RECIPE ID:', recipeId);

    document.getElementById('materialname' + recipeId).style.display = 'block';
    document.getElementById('materialnameEdit' + recipeId).style.display = 'none';
    // this.projects[index].name = (<HTMLInputElement>document.getElementById('materialnameEdit' )).value;
    this.recipeMaterials['material_id'] = Number(this.materialselect);

    document.getElementById('stocksize' + recipeId).style.display = 'block';
    document.getElementById('stocksizeEdit' + recipeId).style.display = 'none';

    this.recipeMaterials['stock_size_length'] = Number((<HTMLInputElement>document.getElementById('mtrlLength' + recipeId)).value);
    this.recipeMaterials['stock_size_height'] = Number((<HTMLInputElement>document.getElementById('mtrlHeight' + recipeId)).value);
    this.recipeMaterials['stock_size_width'] = Number((<HTMLInputElement>document.getElementById('mtrlWidth' + recipeId)).value);

    document.getElementById('shape' + recipeId).style.display = 'block';
    document.getElementById('shapeEdit' + recipeId).style.display = 'none';
    // this.projects[index].name = (<HTMLInputElement>document.getElementById('nameEdit')).value;
    this.recipeMaterials['materialshape_id'] = Number(this.materialshapeselect);

    document.getElementById('mtrlCostperUnit' + recipeId).style.display = 'block';
    document.getElementById('mtrlCostperUnitEdit' + recipeId).style.display = 'none';
    this.recipeMaterials['price'] = Number((<HTMLInputElement>document.getElementById('mtrlCostperUnitEditvalue' + recipeId)).value);

    document.getElementById('mtrlExtras' + recipeId).style.display = 'block';
    document.getElementById('mtrlExtrasEdit' + recipeId).style.display = 'none';
    this.recipeMaterials['extras'] = Number((<HTMLInputElement>document.getElementById('mtrlExtrasEditvalue' + recipeId)).value);

    document.getElementById('mtrlMarkUp' + recipeId).style.display = 'block';
    document.getElementById('mtrlMarkUpEdit' + recipeId).style.display = 'none';
    this.recipeMaterials['markup'] = Number((<HTMLInputElement>document.getElementById('mtrlMarkUpEditvalue' + recipeId)).value);

    document.getElementById('cost_each' + recipeId).style.display = 'block';
    document.getElementById('cost_eachEdit' + recipeId).style.display = 'none';
    this.recipeMaterials['cost_each'] = Number((<HTMLInputElement>document.getElementById('cost_eachEditvalue' + recipeId)).value);

    document.getElementById('materialpencil' + recipeId).style.display = 'block';
    document.getElementById('materialapply' + recipeId).style.display = 'none';
    document.getElementById('materialcancel' + recipeId).style.display = 'none';
    // document.getElementById('removeMaterial').style.display = 'block';

    /* TODO: remove this hard-coded density value */
    // this.recipeMaterials['density'] = '0.0975';

    if (this.projectRecipeMaterial) {
      this.recipesService.addRecipematerial(this.recipeMaterials, recipeId)
        .subscribe(
        data => {
          console.log('recipematerial added : ', data);
          this.projectRecipeMaterial = false;
          Materialize.toast('RECIPE MATERIAL ADDED', 1000);
          this.previousMaterialRecipeResource = {};
          this.calculateMtrlPrices();
          for (let l = 0; l < this.recipes.length; l++) {
            if (this.recipes[l].id == recipeId) {
              this.calculateSummary(l, true);
            }
          }
        },
        error => {

        }
        );
    } else {
      this.recipesService.updateRecipematerial(this.recipeMaterials)
        .subscribe(
        data => {
          console.log('recipematerial updated : ', data);
          Materialize.toast('RECIPE MATERIAL UPDATED', 1000);
          this.calculateMtrlPrices();
          for (let l = 0; l < this.recipes.length; l++) {
            if (this.recipes[l].id == recipeId) {
              this.calculateSummary(l, true);
            }
          }
        },
        error => {

        }
        );
    }
  }

  cancelEditMaterialRow(recipeId: number) {

    if (JSON.stringify(this.previousMaterialRecipeResource) !== '{}') {
      this.recipeMaterials['material_id'] = this.previousMaterialRecipeResource['material_id'];
      this.recipeMaterials['materialunit_id'] = this.previousMaterialRecipeResource['materialunit_id'];
      this.recipeMaterials['stock_size_length'] = this.previousMaterialRecipeResource['stock_size_length'];
      this.recipeMaterials['stock_size_height'] = this.previousMaterialRecipeResource['stock_size_height'];
      this.recipeMaterials['stock_size_width'] = this.previousMaterialRecipeResource['stock_size_width'];
      this.recipeMaterials['price'] = this.previousMaterialRecipeResource['price'];
      this.recipeMaterials['markup'] = this.previousMaterialRecipeResource['markup'];
      this.recipeMaterials['extras'] = this.previousMaterialRecipeResource['extras'];
      this.recipeMaterials['density'] = this.previousMaterialRecipeResource['density'];
      this.recipeMaterials['cost_each'] = this.previousMaterialRecipeResource['cost_each'];
    }

    document.getElementById('materialname' + recipeId).style.display = 'block';
    document.getElementById('materialnameEdit' + recipeId).style.display = 'none';
    document.getElementById('stocksize' + recipeId).style.display = 'block';
    document.getElementById('stocksizeEdit' + recipeId).style.display = 'none';
    document.getElementById('shape' + recipeId).style.display = 'block';
    document.getElementById('shapeEdit' + recipeId).style.display = 'none';
    document.getElementById('mtrlCostperUnit' + recipeId).style.display = 'block';
    document.getElementById('mtrlCostperUnitEdit' + recipeId).style.display = 'none';
    document.getElementById('mtrlExtras' + recipeId).style.display = 'block';
    document.getElementById('mtrlExtrasEdit' + recipeId).style.display = 'none';
    document.getElementById('mtrlMarkUp' + recipeId).style.display = 'block';
    document.getElementById('mtrlMarkUpEdit' + recipeId).style.display = 'none';

    document.getElementById('cost_each' + recipeId).style.display = 'block';
    document.getElementById('cost_eachEdit' + recipeId).style.display = 'none';

    document.getElementById('materialpencil' + recipeId).style.display = 'block';
    document.getElementById('materialapply' + recipeId).style.display = 'none';
    document.getElementById('materialcancel' + recipeId).style.display = 'none';
  }

  handlePartInchChange(event) {
    let target = event.target;
    if (target.checked) {
      this.recipeMaterials['bounding_box_length'] = this.roundNumber((this.recipeMaterials['bounding_box_length'] / 25.4), 2);
      this.recipeMaterials['bounding_box_width'] = this.roundNumber((this.recipeMaterials['bounding_box_width'] / 25.4), 2);
      this.recipeMaterials['bounding_box_height'] = this.roundNumber((this.recipeMaterials['bounding_box_height'] / 25.4), 2);
      this.BoundingsizeInch_unit = true;
    }
  }

  handlePartMetricChange(event) {
    let target = event.target;
    if (target.checked) {
      this.recipeMaterials['bounding_box_length'] = this.roundNumber(((this.recipeMaterials['bounding_box_length']) * 25.4), 2);
      this.recipeMaterials['bounding_box_width'] = this.roundNumber(((this.recipeMaterials['bounding_box_width']) * 25.4), 2);
      this.recipeMaterials['bounding_box_height'] = this.roundNumber(((this.recipeMaterials['bounding_box_height']) * 25.4), 2);
      this.BoundingsizeInch_unit = false;
    }
  }

  tabClicked(recipe: any, currentIndex: number) {

    this.currentTabIndex = currentIndex;

    if (recipe == 0) {
      this.recipePage = false;
      // this.selectedRecipe.id = 0;
    } else {
      this.recipePage = true;
      this.selectedRecipe = recipe;
    }

    //  let recipeResourcesid = this.recipes[0].reciperesources[i];
    this.recipeMaterials = {};
    this.showmaterials = false;
    this.noreciperesources = false;
    for (let l = 0; l < this.recipes.length; l++) {
      if (this.recipes[l].id == recipe.id) {
        if (this.recipes[l].reciperesources.length == 0) {
          this.noreciperesources = true;
          this.loadingTemplate = false;
        }

        if (this.recipes[l].recipematerials.length == 0) {
          this.norecipematerial = true;
        }
        let recipeprojectid = this.recipes[l].project_id;
        let currentrecipeindex = l;
        this.recipesService.getProjectsBoundingBox(recipeprojectid)
          .subscribe(
          data => {
            data = data.split('\\\'').join('\'');
            let projectarray = JSON.parse(data);
            let projectinfo = projectarray.project;
            if (this.recipes[currentrecipeindex].recipematerials.length) {
              for (let i = 0; i < this.recipes[currentrecipeindex].recipematerials.length; i++) {
                let recipematerialid = this.recipes[currentrecipeindex].recipematerials[i].id;
                // this.recipesService.getSpecifiedRecipematerial(recipematerialid)
                //   .subscribe(
                //   data => {
                // let result = JSON.parse(data);
                // result = result.results;

                let result = this.recipematerialsDict[recipematerialid];
                if (!result) {
                  return;
                }
                let materialid = result.material_id;
                if (projectinfo.bounding_box_length) {
                  result.bounding_box_length = projectinfo.bounding_box_length;
                } else {
                  result.bounding_box_length = 0;
                }
                if (projectinfo.bounding_box_width) {
                  result.bounding_box_width = projectinfo.bounding_box_width;
                } else {
                  result.bounding_box_width = 0;
                }
                if (projectinfo.bounding_box_height) {
                  result.bounding_box_height = projectinfo.bounding_box_height;
                } else {
                  result.bounding_box_height = 0;
                }
                result.boundingbox_unit_id = projectinfo.units_id;

                if (result.materialunit_id == 0) {
                  result.materialunit_id = 1;
                }
                this.showmaterials = true;

                if (!projectinfo.units_id) {
                  projectinfo.units_id = 2;
                }

                if (projectinfo.units_id == 2) {
                  (<HTMLInputElement>document.getElementById('PartMetric1' + recipe.id)).checked = true;
                }


                if (!result.stock_size_length) {
                  if (projectinfo.units_id == result.materialunit_id) {
                    result.stock_size_length = projectinfo.bounding_box_length;
                    result.stock_size_width = projectinfo.bounding_box_width;
                    result.stock_size_height = projectinfo.bounding_box_height;
                  } else if (projectinfo.units_id != result.materialunit_id) {
                    if (result.materialunit_id == 1) {
                      result.stock_size_length = this.roundNumber((projectinfo.bounding_box_length / 25.4), 2);
                      result.stock_size_width = this.roundNumber((projectinfo.bounding_box_width / 25.4), 2);
                      result.stock_size_height = this.roundNumber((projectinfo.bounding_box_height / 25.4), 2);
                    } else if (result.materialunit_id == 2) {
                      result.stock_size_length = this.roundNumber(((projectinfo.bounding_box_length) * 25.4), 2);
                      result.stock_size_width = this.roundNumber(((projectinfo.bounding_box_width) * 25.4), 2);
                      result.stock_size_height = this.roundNumber(((projectinfo.bounding_box_height) * 25.4), 2);
                    }
                  }
                }
                if (result.materialunit_id == 1) {
                  this.stocksizeInch_unit = true;
                } else if (result.materialunit_id == 2) {
                  this.stocksizeInch_unit = false;
                }

                result.density = this.materialDensityDict[materialid];

                this.recipeMaterials = result;
                console.log('recipe materials : ', this.recipeMaterials);
                this.calculateMtrlPrices();
                // },
                // error => {
                // });
              }
            } else {
              let result = {};
              result['bounding_box_length'] = projectinfo.bounding_box_length;
              result['bounding_box_width'] = projectinfo.bounding_box_width;
              result['bounding_box_height'] = projectinfo.bounding_box_height;
              result['boundingbox_unit_id'] = projectinfo.units_id;
              this.showmaterials = true;

              if (projectinfo.units_id == 2) {
                (<HTMLInputElement>document.getElementById('PartMetric1' + recipe.id)).checked = true;
              }

              result['material_id'] = projectinfo.material_id;
              result['materialunit_id'] = this.materialUnitDict[projectinfo.material_id];
              let projectsmaterialunitid = this.materialUnitDict[projectinfo.material_id];
              if (projectinfo.units_id == projectsmaterialunitid) {
                result['stock_size_length'] = projectinfo.bounding_box_length;
                result['stock_size_width'] = projectinfo.bounding_box_width;
                result['stock_size_height'] = projectinfo.bounding_box_height;
              } else if (projectinfo.units_id != projectsmaterialunitid) {
                if (projectsmaterialunitid == 1) {
                  result['stock_size_length'] = this.roundNumber((projectinfo.bounding_box_length / 25.4), 2);
                  result['stock_size_width'] = this.roundNumber((projectinfo.bounding_box_width / 25.4), 2);
                  result['stock_size_height'] = this.roundNumber((projectinfo.bounding_box_height / 25.4), 2);
                } else if (projectsmaterialunitid == 2) {
                  result['stock_size_length'] = this.roundNumber(((projectinfo.bounding_box_length) * 25.4), 2);
                  result['stock_size_width'] = this.roundNumber(((projectinfo.bounding_box_width) * 25.4), 2);
                  result['stock_size_height'] = this.roundNumber(((projectinfo.bounding_box_height) * 25.4), 2);
                }
              }


              result['density'] = this.materialDensityDict[projectinfo.material_id];
              this.projectRecipeMaterial = true;
              this.recipeMaterials = result;
              this.calculateMtrlPrices();

            }
            this.calculateSummary(currentrecipeindex, true);

          },
          error => {

          });
      }
    }

  }

  roundNumber(number, precision) {
    precision = Math.abs(parseInt(precision)) || 0;
    let multiplier = Math.pow(10, precision);
    return (Math.round(number * multiplier) / multiplier);
  }

  on_materialPrice_Change(value, recipeId) {
    console.log('Material price changed value : ', value);

    this.recipeMaterials['price'] = Number(value);
    this.changeMtrlCost = false;
    // this.changeMtrlProperties = true;
    this.calculateMtrlPrices();
    // for (let l = 0; l < this.recipes.length; l++)
    //   {
    //     if (this.recipes[l].id == recipeId) {
    //      this.calculateSummary(l, true);
    //     }
    //   }

  }

  on_materialcost_each_Change(value, recipeId) {

    let volume = this.recipeMaterials['stock_size_length'] * this.recipeMaterials['stock_size_width'] * this.recipeMaterials['stock_size_height'];

    let weight = volume * this.recipeMaterials['density'];
    let perunitPriceWithMarkup = Number(value);

    let perunitPriceWithoutMarkup = (perunitPriceWithMarkup * 100) / (this.recipeMaterials['markup'] + 100);
    this.recipeMaterials['price'] = perunitPriceWithoutMarkup / weight;
    this.changeMtrlCost = true;

  }

  calculateMtrlPrices() {
    let volume = this.recipeMaterials['stock_size_length'] * this.recipeMaterials['stock_size_width'] * this.recipeMaterials['stock_size_height'];
    let weight = volume * this.recipeMaterials['density'];

    let perunitPriceWithoutMarkup = weight * this.recipeMaterials['price'];
    let perunitPriceWithMarkup = perunitPriceWithoutMarkup + (perunitPriceWithoutMarkup * this.recipeMaterials['markup'] / 100);

    perunitPriceWithMarkup = Number(perunitPriceWithMarkup.toFixed(2));

    if (!perunitPriceWithMarkup) {
      perunitPriceWithMarkup = 0;
    }
    if (!this.changeMtrlCost) {
      this.recipeMaterials['cost_each'] = perunitPriceWithMarkup;
    } else {
      perunitPriceWithMarkup = this.recipeMaterials['cost_each'];
    }


    let lotsize = Number((<HTMLInputElement>document.getElementById('Material_lotsize')).value);
    if (!lotsize) {
      this.recipeMaterials['lotsize'] = 1;
      lotsize = 1;
    }

    let totalExtraMtrlCost = 0;
    if (this.recipeMaterials['extras']) {
      totalExtraMtrlCost = (perunitPriceWithMarkup * this.recipeMaterials['extras']);
    } else {
      totalExtraMtrlCost = 0;
    }
    this.recipeMaterials['extraMtrlCost'] = totalExtraMtrlCost;
    // this.recipeMaterials['totalMtrlCost'] = totalExtraMtrlCost;

  }

  calculateSummary(currentrecipeindex, updatebackend) {
    // this.recipes
    let lot_cost = 0;
    let unit_cost = 0; let nre_cost = 0;
    if (this.recipeCategoryDict[this.recipes[currentrecipeindex].id]) {
      for (let m = 0; m < this.recipeCategoryDict[this.recipes[currentrecipeindex].id].length; m++) {
        lot_cost = lot_cost + this.recipeCategoryDict[this.recipes[currentrecipeindex].id][m].lotCost;
        unit_cost = unit_cost + this.recipeCategoryDict[this.recipes[currentrecipeindex].id][m].unitCost;
        nre_cost = nre_cost + this.recipeCategoryDict[this.recipes[currentrecipeindex].id][m].NREcost;
        // var total_Cost = unit_cost + lot_cost + nre_cost;
        // this.recipeCategoryDict[this.recipes[currentrecipeindex].id][m].SectionTotalCost = Number(total_Cost);
      }
    }
    let materialcost = this.recipeMaterials['cost_each'];
    let extraMaterialCalculations = 0;
    if (this.recipeMaterials['extraMtrlCost']) {
      extraMaterialCalculations = this.recipeMaterials['extraMtrlCost'];
      lot_cost = lot_cost + extraMaterialCalculations;
    }

    if (!materialcost) {
      materialcost = 0;
    }
    if (updatebackend) {
      this.recipes[currentrecipeindex].lotSize = 1;
    }

    this.recipes[currentrecipeindex].lot_cost = lot_cost;
    // this.recipes[currentrecipeindex].unit_cost = ( unit_cost + materialcost ) + (( lot_cost+ perunitprice ) / this.recipes[currentrecipeindex].lotSize );
    this.recipes[currentrecipeindex].unit_cost = ((lot_cost / this.recipes[currentrecipeindex].lotSize) + unit_cost + materialcost);
    this.recipes[currentrecipeindex].nre_cost = nre_cost;
    this.recipes[currentrecipeindex].material_cost = materialcost *  this.recipes[currentrecipeindex].lotSize;

    let totalcost = (this.recipes[currentrecipeindex].unit_cost * this.recipes[currentrecipeindex].lotSize) + this.recipes[currentrecipeindex].nre_cost;
    this.recipes[currentrecipeindex].total_cost = totalcost;

    this.recipeMaterials['MtrlToTotalCostPrcnt'] = (materialcost / totalcost) * 100;

    if (updatebackend) {
      this.updateRecipeSummary(this.recipes[currentrecipeindex]);
    }
  }

  updateRecipeSummary(recipes: any) {
    let recipeUpdateValues = {
      id: recipes.id,
      is_default: recipes.is_default,
      project_id: recipes.project_id,
      lotSize: recipes.lotSize,
      nre_cost: recipes.nre_cost,
      lot_cost: recipes.lot_cost,
      unit_cost: recipes.unit_cost,
      material_cost: recipes.material_cost,
      total_cost: recipes.total_cost
    };

    this.recipesService.updateRecipe(recipeUpdateValues)
      .subscribe(
      data => {
        console.log('updated recipe resource : ', data);
      },
      error => {
        console.log('error on recipe resource : ', error);
      });


  }

  resourceSelectedCategoryIdChange() {

    this.resourceSelectedCategory = Number((<HTMLInputElement>document.getElementById('resourceSelectedCategoryId')).value);
    this.newrecipeResourcesDict = {};
    this.newrecipeResourcesLength = 0;
    this.checkedIndexes = [];
  }

  opentabFor(i) {
    document.getElementById('recipetab' + i).click();
  }

  editLotSize(recipeId: number) {

    document.getElementById('lotSizeValue' + recipeId).style.display = 'none';
    document.getElementById('lotSizeValueEdit' + recipeId).style.display = 'block';

    document.getElementById('lotSizePencil' + recipeId).style.display = 'none';
    document.getElementById('lotSizePencilApply' + recipeId).style.display = 'block';
    document.getElementById('lotSizePencilCancel' + recipeId).style.display = 'block';
  }

  saveLotSize(recipeId: number) {

    for (let l = 0; l < this.recipes.length; l++) {
      if (this.recipes[l].id == recipeId) {
        this.recipes[l].lotSize = (<HTMLInputElement>document.getElementById('lotSizeValueEdit' + recipeId)).value;
        this.calculateSummary(l, false);
      }
    }

    document.getElementById('lotSizeValue' + recipeId).style.display = 'block';
    document.getElementById('lotSizeValueEdit' + recipeId).style.display = 'none';
    document.getElementById('lotSizePencil' + recipeId).style.display = 'block';
    document.getElementById('lotSizePencilApply' + recipeId).style.display = 'none';
    document.getElementById('lotSizePencilCancel' + recipeId).style.display = 'none';
    Materialize.toast('DATABASE WILL NOT BE UPDATED FOR CHANGE IN LOTSIZE.', 1500);

  }

  cancelLotSize(recipeId: number) {
    document.getElementById('lotSizeValue' + recipeId).style.display = 'block';
    document.getElementById('lotSizeValueEdit' + recipeId).style.display = 'none';

    document.getElementById('lotSizePencil' + recipeId).style.display = 'block';
    document.getElementById('lotSizePencilApply' + recipeId).style.display = 'none';
    document.getElementById('lotSizePencilCancel' + recipeId).style.display = 'none';
  }

  // Method to save lot size
  saveChip() {
    console.log('Method to save lot size called from html template.');
  }

  calculateStarRating(recipeindex, rating) {
    this.filledstar = Math.floor(rating / 1);
    this.halfstar = rating % 1;
    if (this.halfstar) {
      this.halfstar = 1;
    }
    this.emptystar = Math.floor(5 - rating);

    this.recipes[recipeindex].filledstar = this.filledstar;
    this.recipes[recipeindex].halfstar = this.halfstar;
    this.recipes[recipeindex].emptystar = this.emptystar;
  }

  createRange(number) {
    let items: number[] = [];
    for (let i = 1; i <= number; i++) {
      items.push(i);
    }
    return items;
  }

  copyRecipeModal(recipe: any) {
    this.waiticon = '';
    console.log('SELECTED RECIPE:', recipe);
    this.selectedRecipe = recipe;
    this.modalCopyRecipeAction.emit({ action: 'modal', params: ['open'] });
  }

  copyRecipe() {
    let recipetocopy = {
      id: this.selectedRecipe.id,
      name: (<HTMLInputElement>document.getElementById('copyRecipeName')).value
    };

    let recipeName = (<HTMLInputElement>document.getElementById('copyRecipeName')).value;
    if (!recipeName) {
      Materialize.toast('Recipe name is a required field!', 1000);
      return;
    }
    this.waiticon = 'fa right fa-spinner fa-pulse';
    this.recipesService.copyRecipe(recipetocopy)
      .subscribe(
      data => {
        console.log('copied recipe:', data);

        this.waiticon = '';
        Materialize.toast('RECIPE ' + this.selectedRecipe.name + ' COPIED SUCCESSFULLY.', 1000);
        console.log('RECIPE COPIED SUCCESSFULLY.');
        // this.modalConfirmRemoveRecipeAction.emit({ action: 'modal', params: ['close'] });
        // this.recipes.splice(this.currentTabIndex, 1);
        this.getRecipe(this.recipeProjectid);
        this.modalCopyRecipeAction.emit({ action: 'modal', params: ['close'] });
        // this.updateAllVariables();

      },
      error => {
        this.waiticon = '';
        console.log('error copying recipe:', error);
        Materialize.toast('ERROR COPYING RECIPE', 1500);
        this.modalCopyRecipeAction.emit({ action: 'modal', params: ['close'] });
      });

  }


  onRecipeQuote(recipe, index) {
    this.storeProjectInfo(recipe, index);
    localStorage.setItem('mr_recipedata_For_Quote_From_Recipe', 'true');
    this.router.navigate(['/quote/'  + recipe.project_id ]);
  }

  storeProjectInfo(recipe, index) {

    let sCurrentRecipie = JSON.stringify(recipe.id);
    let sRecipies = JSON.stringify(this.recipes);
    let sProject = JSON.stringify(this.project);

    let materials = JSON.stringify(this.materials);
    localStorage.setItem('mr_material', materials);

    localStorage.setItem('mr_project_For_Quote_From_Recipe', sProject);
    localStorage.setItem('mr_recipe_For_Quote_From_Recipe', sRecipies);
    localStorage.setItem('mr_defauldRecipe_For_Quote_From_Recipe', sCurrentRecipie);
  }

}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/recipes/recipes.component.ts